import i18n from '../../managers/i18n'

i18n.register(
  'en-US',
  {
    placeholder: 'Select',
    clear: 'Clear',
    noData: 'No result',
    selectAll: 'Select all'
  },
  {
    ns: 'cascader'
  }
)
